import yup from 'yup';

const schema = yup.object().shape({
  pairingInput: yup.string().required('This field is required'),
});

export default schema;
